import { render, staticRenderFns } from "./prepaymentoverview.vue?vue&type=template&id=a4b5ef94&scoped=true&"
import script from "./prepaymentoverview.vue?vue&type=script&lang=js&"
export * from "./prepaymentoverview.vue?vue&type=script&lang=js&"
import style0 from "./prepaymentoverview.vue?vue&type=style&index=0&id=a4b5ef94&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b5ef94",
  null
  
)

export default component.exports